"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/FilterPanel.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("22c614"),
    marko_node0 = marko_createElement("a", {
        "data-toggle": "dropdown",
        "class": "dropdown-toggle"
      }, "1", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-filter-alt font-medium-5"
        }, null, null, 0),
    marko_attrs0 = {
        "class": "dropdown-menu"
      },
    marko_attrs1 = {
        "class": "px-2 pt-4"
      },
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_attrs3 = {
        "class": "checkbox"
      },
    marko_node1 = marko_createElement("input", {
        type: "checkbox",
        "class": "checkbox-input",
        id: "dropdownCheck1"
      }, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "for": "dropdownCheck1"
      },
    marko_attrs5 = {
        "class": "form-group"
      },
    marko_attrs6 = {
        "class": "checkbox"
      },
    marko_node2 = marko_createElement("input", {
        type: "checkbox",
        "class": "checkbox-input",
        id: "dropdownCheck1"
      }, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "for": "dropdownCheck1"
      },
    marko_attrs8 = {
        "class": "form-group"
      },
    marko_attrs9 = {
        "class": "checkbox"
      },
    marko_node3 = marko_createElement("input", {
        type: "checkbox",
        "class": "checkbox-input",
        id: "dropdownCheck1"
      }, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs10 = {
        "for": "dropdownCheck1"
      },
    marko_node4 = marko_createElement("div", {
        "class": "dropdown-divider"
      }, "21", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs11 = {
        "class": "px-2 pt-4"
      },
    marko_attrs12 = {
        "class": "form-group"
      },
    marko_attrs13 = {
        "for": "exampleDropdownFormEmail1"
      },
    marko_attrs14 = {
        name: "",
        "class": "form-control select2"
      },
    marko_attrs15 = {
        value: "public"
      },
    marko_attrs16 = {
        value: "private"
      },
    marko_attrs17 = {
        value: "reserved"
      },
    marko_attrs18 = {
        "class": "form-group"
      },
    marko_attrs19 = {
        "for": "exampleDropdownFormPassword1"
      },
    marko_attrs20 = {
        name: "",
        "class": "form-control select2"
      },
    marko_attrs21 = {
        value: "public"
      },
    marko_attrs22 = {
        value: "private"
      },
    marko_attrs23 = {
        value: "reserved"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue(input.class)
    }, "0", component, null, 1);

  out.n(marko_node0, component);

  out.be("div", marko_attrs0, "3", component);

  out.be("form", null, "4", component);

  out.be("div", marko_attrs1, "5", component);

  out.be("div", marko_attrs2, "6", component);

  out.be("div", marko_attrs3, "7", component);

  out.n(marko_node1, component);

  out.be("label", marko_attrs4, "9", component);

  Locale_tag({
      text: "Beginer"
    }, out, __component, "10");

  out.ee();

  out.ee();

  out.ee();

  out.be("div", marko_attrs5, "11", component);

  out.be("div", marko_attrs6, "12", component);

  out.n(marko_node2, component);

  out.be("label", marko_attrs7, "14", component);

  Locale_tag({
      text: "Medium"
    }, out, __component, "15");

  out.ee();

  out.ee();

  out.ee();

  out.be("div", marko_attrs8, "16", component);

  out.be("div", marko_attrs9, "17", component);

  out.n(marko_node3, component);

  out.be("label", marko_attrs10, "19", component);

  Locale_tag({
      text: "Advanced"
    }, out, __component, "20");

  out.ee();

  out.ee();

  out.ee();

  out.ee();

  out.n(marko_node4, component);

  out.be("div", marko_attrs11, "22", component);

  out.be("div", marko_attrs12, "23", component);

  out.be("label", marko_attrs13, "24", component);

  Locale_tag({
      text: "Availability"
    }, out, __component, "25");

  out.ee();

  out.be("select", marko_attrs14, "26", component);

  out.be("option", marko_attrs15, "27", component);

  Locale_tag({
      text: "Public"
    }, out, __component, "28");

  out.ee();

  out.be("option", marko_attrs16, "29", component);

  Locale_tag({
      text: "Private"
    }, out, __component, "30");

  out.ee();

  out.be("option", marko_attrs17, "31", component);

  Locale_tag({
      text: "Reserved"
    }, out, __component, "32");

  out.ee();

  out.ee();

  out.ee();

  out.be("div", marko_attrs18, "33", component);

  out.be("label", marko_attrs19, "34", component);

  Locale_tag({
      text: "Difficulty Level"
    }, out, __component, "35");

  out.ee();

  out.be("select", marko_attrs20, "36", component);

  out.be("option", marko_attrs21, "37", component);

  Locale_tag({
      text: "Beginer"
    }, out, __component, "38");

  out.ee();

  out.be("option", marko_attrs22, "39", component);

  Locale_tag({
      text: "Medium"
    }, out, __component, "40");

  out.ee();

  out.be("option", marko_attrs23, "41", component);

  Locale_tag({
      text: "Advanced"
    }, out, __component, "42");

  out.ee();

  out.ee();

  out.ee();

  out.ee();

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
